import { t } from 'javascripts/utils/withTranslation';
import { generateIcon as icon } from 'components/_particles/icon/icon';
import { lory } from '@rsm/allfarblori';
import h from 'hyperscript';

class AssociationBoxSlider {
  constructor($el) {
    this.$el = $el;

    this.$slides = this.$el.querySelectorAll('.association-box__item');
    this.$slidesIndexes = [...this.$slides].map((slide, index) => index);
    this.totalSlides = this.$slides.length;
    this.$inner = this.$el.querySelector('.association-box__inner');
    this.$slidesContainer = this.$el.querySelector('.association-box__items-wrap');

    this.$el.addEventListener('before.lory.init', () => {
      this.handleLoryInit();
    });

    this.$el.addEventListener('after.lory.init', () => {
      this.$el.classList.add('quote-box--initialized');
    });

    this.lory = lory(this.$el, {
      rewind: true,
      rewindPrev: true,
      rewindSpeed: 200,
      slideSpeed: 350,
      ease: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
      classNameFrame: 'association-box__inner',
      classNameSlideContainer: 'association-box__items-wrap',
      classNamePrevCtrl: 'association-box__arrow--prev',
      classNameNextCtrl: 'association-box__arrow--next',
      classNameDisabledPrevCtrl: 'association-box__arrow--disabled',
      classNameDisabledNextCtrl: 'association-box__arrow--disabled',
    });
  }

  handleLoryInit() {
    this.$slidesContainer.scrollLeft = 0;
    this.renderArrows();
  }

  renderArrows() {
    this.$controlPrev = h(
      'button.association-box__arrow.association-box__arrow--prev',
      {
        type: 'button',
        tabIndex: '-1',
        attrs: {
          'aria-label': t('Vorheriger Fakt'),
        },
      },
      icon({
        icon: 'arrow-left',
        viewBox: '0 0 70 200',
        className: 'association-box__arrow-icon',
      }),
    );

    this.$controlNext = h(
      'button.association-box__arrow.association-box__arrow--next',
      {
        type: 'button',
        tabIndex: '-1',
        attrs: {
          'aria-label': t('Nächster Fakt'),
        },
      },
      icon({
        icon: 'arrow-right',
        viewBox: '0 0 70 200',
        className: 'association-box__arrow-icon',
      }),
    );

    const $controls = h('.association-box__controls');
    $controls.appendChild(this.$controlPrev);
    $controls.appendChild(this.$controlNext);

    this.$inner.appendChild($controls);
  }
}

// Init slider
document.querySelectorAll('.association-box--slider').forEach($slider => new AssociationBoxSlider($slider));
